import axios from "../axios";
import { CREATE_FUTURE_CUSTOMER_API } from "../../global/ApiUrl";

export const createFutureCustomer = async (payload) => {
  try {
    const response = await axios.post(CREATE_FUTURE_CUSTOMER_API, payload);
    return response;

  } catch (error) {
    console.log("createFutureCustomer catch block", error);
    return error;

  }

};
